export default __webpack_public_path__ + "static/media/Hydrabad.85907925.png";